
<div [formGroup]="group" class="quantity">
    <h2 *ngIf="config.title && titleHotelForm === true" class="form-title">{{ config.title }}</h2>

    <h2 *ngIf="titleHotelForm === false" class="form-title">{{ Yii.t('wui-shared-js', 'Voyageurs') }}</h2>

    <div class="quantity-rooms-traveller">
        <div class="quantity-traveller"
            [ngClass]="{'col-to-row-s-mb': isFieldFlexFlowRow}"
            *ngIf="config.hasTraveller">
            <number class="field-sep fix-width-1 e2e-adult-field"
                [labelPosition]="labelPosition"
                [disabled]="readOnlyTravellers"
                [showPlusAndMinus]="!readOnlyTravellers"
                [fieldConfig]="{
                    formGroup: group,
                    formControlName: 'adult',
                    min: 0,
                    max: maxTravellers['adult'],
                    label: wording.adt,
                    disabled: readOnlyTravellers,
                    fixed: 0
                }"></number>

            <number class="field-sep fix-width-1 e2e-child-field"
                    [labelPosition]="labelPosition"
                    [disabled]="readOnlyTravellers"
                    [showPlusAndMinus]="!readOnlyTravellers"
                    [fieldConfig]="{
                formGroup: group,
                formControlName: 'child',
                min: 0,
                max: maxTravellers['child'],
                label: wording.chd,
                disabled: readOnlyTravellers,
                fixed: 0
            }"></number>

            <number class="field-sep fix-width-1 e2e-infant-field"
                    [labelPosition]="labelPosition"
                    [disabled]="readOnlyTravellers"
                    [showPlusAndMinus]="!readOnlyTravellers"
                    [fieldConfig]="{
                formGroup: group,
                formControlName: 'infant',
                min: 0,
                max: maxTravellers['infant'],
                label: wording.inf,
                disabled: readOnlyTravellers,
                fixed: 0
            }"></number>

            <number *ngIf="config.hasRoom"
                    class="field-sep fix-width-1 e2e-rooming-field"
                    [labelPosition]="labelPosition"
                    [fieldConfig]="{
                formGroup: group,
                formControlName: 'rooming',
                min: 1,
                max: 10,
                label: wording.room,
                disabled: readOnlyTravellers,
                fixed: 0
            }"></number>

        </div>

    </div>
</div>
